export default __webpack_public_path__ + "static/media/about2.fa47431c.jpg";